import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
const COLLAGE_URL = 'https://cdn.magicpatterns.com/uploads/uwg8UUSAbHo4S88PTtuuqK/ChatGPT_Image_Feb_18,_2026,_12_46_06_AM.png';
export function BrandStory() {
  const companies = [{
    name: 'Amazon',
    posX: '0%',
    posY: '0%'
  }, {
    name: 'J.P.Morgan Chase',
    posX: '50%',
    posY: '0%'
  }, {
    name: 'Microsoft',
    posX: '100%',
    posY: '0%'
  }, {
    name: 'Goldman Sachs',
    posX: '0%',
    posY: '33.33%'
  }, {
    name: 'Deloitte',
    posX: '50%',
    posY: '33.33%'
  }, {
    name: 'Google',
    posX: '100%',
    posY: '33.33%'
  }, {
    name: 'McKinsey & Company',
    posX: '0%',
    posY: '66.66%'
  }, {
    name: 'Johnson & Johnson',
    posX: '50%',
    posY: '66.66%'
  }, {
    name: 'PwC',
    posX: '100%',
    posY: '66.66%'
  }, {
    name: 'Salesforce',
    posX: '50%',
    posY: '100%'
  }];
  return <Section background="navy" className="relative overflow-hidden" data-id="element-16">
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-17">
        <div className="absolute left-0 top-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] bg-repeat" data-id="element-18" />
      </div>

      <div className="relative z-10 text-center max-w-6xl mx-auto" data-id="element-19">
        <FadeIn data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-serif text-sage-50 mb-4" data-id="element-21">
            Our Network
          </h2>
          <p className="text-accent-400 text-sm uppercase tracking-widest mb-8" data-id="element-22">
            Trusted by Leading Organizations
          </p>
          <div className="h-[1px] w-24 bg-white/[0.12] mb-12 mx-auto" data-id="element-23" />
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-24">
          <p className="text-lg text-sage-300 leading-relaxed font-light mb-16" data-id="element-25">
            We are an executive recruitment firm partnering with a select group
            of organizations across multiple industries to identify and appoint
            senior and C-suite leadership.
          </p>
        </FadeIn>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-6 mb-16" data-id="element-26">
          {companies.map((company, index) => <FadeIn key={index} delay={0.3 + index * 0.05} className="flex items-center justify-center" data-id="element-27">
              <div className="group cursor-default w-full" data-id="element-28">
                <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden border border-white/[0.1] group-hover:border-accent-400/40 transition-all duration-300 shadow-lg group-hover:shadow-accent-400/10" data-id="element-29">
                  <div className="absolute inset-0 bg-no-repeat transition-transform duration-500 group-hover:scale-110" style={{
                backgroundImage: `url(${COLLAGE_URL})`,
                backgroundSize: '300% 400%',
                backgroundPosition: `${company.posX} ${company.posY}`
              }} data-id="element-30" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-31" />
                </div>
                <p className="mt-3 text-sage-300 text-xs md:text-sm tracking-wider text-center font-medium group-hover:text-white transition-colors duration-300" data-id="element-32">
                  {company.name}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.8} data-id="element-33">
          <p className="text-sm text-sage-400/60 italic" data-id="element-34">
            …and many more. These represent just a fraction of the organizations
            we partner with across technology, finance, healthcare, consulting,
            and beyond.
          </p>
        </FadeIn>
      </div>
    </Section>;
}